const NOTICE_CATEGORY_SYSTEM = "NTCG001"
const NOTICE_DISPLAY_HIDDEN = "NTDP002"

export const Variables = {
  NOTICE_CATEGORY_SYSTEM,
  NOTICE_DISPLAY_HIDDEN,
}
